import {
  CONST_CLAIM_ROUDING_KIRIAGE,
  CONST_CLAIM_ROUDING_KIRISUTE,
  CONST_CLAIM_ROUDING_SISYAGONYU,
  CONST_CLAIM_ROUDING_SYORINASI,
} from "../constant/Constants";
import { EntityConditionImple } from "../entity/EntityConditionImple";
import { EntityVariationImple } from "../entity/EntityVariationImple";

/**
 * メディアデプトプロジェクト内に関する金額の処理を担当する
 */
export class CommonPrice4FU {
  /**
   * EntityVariationImpleに設定されている情報から、売上金額を返す。
   * 情報が不足している場合、設定金額をそのまま返す。
   * @param entityClaim
   * @param authData
   * @returns
   */
  public static async cnvVariationPrice(
    itemCount: number,
    variation: EntityVariationImple
  ): Promise<number> {
    //準備
    //---------------
    if (!this.isInteger(variation.c_variation_price)) {
      return 0;
    }
    if (!this.isInteger(variation.c_variation_price_type)) {
      return variation.c_variation_price!;
    }
    if (!Number.isFinite(variation.c_variation_margin_sales)) {
      return variation.c_variation_price!;
    }

    if (itemCount < 1) {
      itemCount = 1;
    }

    //算出
    //---------------
    if (variation.c_variation_price_type == 1) {
      //グロス
      const ratio: number = variation.c_variation_margin_sales! / 100;
      const margin = variation.c_variation_price! * ratio;
      return Math.round(variation.c_variation_price! - margin) * itemCount;
    } else {
      //ネット
      return variation.c_variation_price! * itemCount;
    }
  }
  /**
   * EntityConditionImple設定されている情報から、合計仕入金額を返す。
   * @param entityClaim
   * @param authData
   * @returns
   */
  public static async cnvSupplySumPrice(
    conditions: EntityConditionImple[]
  ): Promise<number> {
    let res = 0;

    for (let index = 0; index < conditions.length; index++) {
      if (
        conditions[index].c_condition_price != null &&
        this.isInteger(conditions[index].c_condition_price)
      ) {
        res += conditions[index].c_condition_price!;
      }
    }

    return res;
  }

  /**
   * 金額と小数点以下の丸め方法（0:四捨五入;1:切り上げ;2:切り捨て;3:処理なし）を受け取って、丸めた金額を返す。
   */
  public static cnvIntPrice(price: number, rounding: number): number {
    if (rounding == CONST_CLAIM_ROUDING_SYORINASI) {
      return price;
    }

    switch (rounding) {
      case CONST_CLAIM_ROUDING_SISYAGONYU:
        return Math.round(price);
      case CONST_CLAIM_ROUDING_KIRIAGE:
        return Math.ceil(price);
      case CONST_CLAIM_ROUDING_KIRISUTE:
        return Math.floor(price);

      default:
        throw new Error(rounding + ":roundingの値が不正です。");
    }
  }

  //---------------------------------
  /**
   * 整数かどうかをbool型で返す。
   * @param value
   * @returns
   */
  public static isInteger(value: any): boolean {
    return typeof value === "number" && value % 1 === 0;
  }

  /**
   * 税抜き金額計算して返す。
   * 業務仕様的に、内税以外の税率の場合、入力金額は税抜き金額と同義なので、そのまま返す。
   * 内税の時のみ、入力値を税込み金額として扱い、税抜き金額を計算して返す。
   */
  public static calcExcludTax(
    salesPrice: number,
    taxRate: number,
    rounding: number
  ): string {
    let res = "";

    //開始判定
    //-------------
    if (salesPrice == null) {
      res = "0";
      return res;
    }

    //計算開始
    //-------------
    let sum = 0;
    let sum_str = salesPrice.toString();

    //税込金額計算
    //-------------

    //数字にパース
    sum_str = sum_str.replace(/,/g, "");
    sum = Number(sum_str);
    let sumTmp = "";
    let taxiTmp = 0;

    switch (taxRate) {
      case null:
        //消費税未設定：金額がそのまま税抜金額に入る
        sumTmp = salesPrice.toString();
        while (sumTmp != (sumTmp = sumTmp.replace(/^(-?\d+)(\d{3})/, "$1,$2")));
        res = sumTmp;
        break;
      case 1:
        //5%
        sumTmp = salesPrice.toString();
        while (sumTmp != (sumTmp = sumTmp.replace(/^(-?\d+)(\d{3})/, "$1,$2")));
        res = sumTmp;
        break;
      case 2:
        //8%
        sumTmp = salesPrice.toString();
        while (sumTmp != (sumTmp = sumTmp.replace(/^(-?\d+)(\d{3})/, "$1,$2")));

        res = sumTmp;
        break;
      case 3:
        //10%
        sumTmp = salesPrice.toString();
        while (sumTmp != (sumTmp = sumTmp.replace(/^(-?\d+)(\d{3})/, "$1,$2")));
        res = sumTmp;
        break;
      case 4:
        //内税　計算される
        //-------
        //消費税計算
        taxiTmp = salesPrice - salesPrice / 1.1;
        sumTmp = CommonPrice4FU.cnvIntPrice(
          salesPrice - taxiTmp,
          rounding
        ).toString();

        while (sumTmp != (sumTmp = sumTmp.replace(/^(-?\d+)(\d{3})/, "$1,$2")));
        res = sumTmp;
        break;
      default:
        //消費税未設定：金額がそのまま税込み金額に入る
        sumTmp = salesPrice.toString();
        while (sumTmp != (sumTmp = sumTmp.replace(/^(-?\d+)(\d{3})/, "$1,$2")));
        res = sumTmp;
        break;
    }

    return res;
  }
  /**
   * 税込み金額計算
   */
  public static calcTax(
    salesPrice: number,
    taxRate: number,
    rounding: number
  ): string {
    let res = "";

    //開始判定
    //-------------
    if (salesPrice == null) {
      res = "0";
      return res;
    }

    //計算開始
    //-------------
    let sum = 0;
    let sum_str = salesPrice.toString();

    //税込金額計算
    //-------------

    //数字にパース
    sum_str = sum_str.replace(/,/g, "");
    sum = Number(sum_str);
    let sumTmp = "";

    switch (taxRate) {
      case null:
        //消費税未設定：金額がそのまま税込み金額に入る
        sumTmp = CommonPrice4FU.cnvIntPrice(sum, rounding!).toString();
        while (sumTmp != (sumTmp = sumTmp.replace(/^(-?\d+)(\d{3})/, "$1,$2")));
        res = sumTmp;
        break;
      case 1:
        //5%
        sumTmp = CommonPrice4FU.cnvIntPrice(
          (1 + 5 / 100) * sum,
          rounding!
        ).toString();
        while (sumTmp != (sumTmp = sumTmp.replace(/^(-?\d+)(\d{3})/, "$1,$2")));
        res = sumTmp;
        break;
      case 2:
        //8%
        sumTmp = CommonPrice4FU.cnvIntPrice(
          (1 + 8 / 100) * sum,
          rounding!
        ).toString();
        while (sumTmp != (sumTmp = sumTmp.replace(/^(-?\d+)(\d{3})/, "$1,$2")));

        res = sumTmp;
        break;
      case 3:
        //10%
        sumTmp = CommonPrice4FU.cnvIntPrice(
          (1 + 10 / 100) * sum,
          rounding!
        ).toString();
        while (sumTmp != (sumTmp = sumTmp.replace(/^(-?\d+)(\d{3})/, "$1,$2")));
        res = sumTmp;
        break;
      case 4:
        //内税　ここでは金額がそのまま税込み金額に入る
        sumTmp = CommonPrice4FU.cnvIntPrice(sum, rounding!).toString();
        while (sumTmp != (sumTmp = sumTmp.replace(/^(-?\d+)(\d{3})/, "$1,$2")));
        res = sumTmp;
        break;
      default:
        //消費税未設定：金額がそのまま税込み金額に入る
        sumTmp = CommonPrice4FU.cnvIntPrice(sum, rounding!).toString();
        while (sumTmp != (sumTmp = sumTmp.replace(/^(-?\d+)(\d{3})/, "$1,$2")));
        res = sumTmp;
        break;
    }

    return res;
  }

  /**
   * 税込み金額計算 カンマなし
   */
  public static calcTax_noComma(
    salesPrice: number,
    taxRate: number,
    rounding: number
  ): string {
    let res = "";

    //開始判定
    //-------------
    if (salesPrice == null) {
      res = "0";
      return res;
    }

    //計算開始
    //-------------
    let sum = 0;
    let sum_str = salesPrice.toString();

    //税込金額計算
    //-------------

    //数字にパース
    sum_str = sum_str.replace(/,/g, "");
    sum = Number(sum_str);
    let sumTmp = "";

    switch (taxRate) {
      case null:
        //消費税未設定：金額がそのまま税込み金額に入る
        sumTmp = CommonPrice4FU.cnvIntPrice(sum, rounding!).toString();
        res = sumTmp;
        break;
      case 1:
        //5%
        sumTmp = CommonPrice4FU.cnvIntPrice(
          (1 + 5 / 100) * sum,
          rounding!
        ).toString();
        res = sumTmp;
        break;
      case 2:
        //8%
        sumTmp = CommonPrice4FU.cnvIntPrice(
          (1 + 8 / 100) * sum,
          rounding!
        ).toString();
        res = sumTmp;
        break;
      case 3:
        //10%
        sumTmp = CommonPrice4FU.cnvIntPrice(
          (1 + 10 / 100) * sum,
          rounding!
        ).toString();
        res = sumTmp;
        break;
      case 4:
        //内税　ここでは金額がそのまま税込み金額に入る
        sumTmp = CommonPrice4FU.cnvIntPrice(sum, rounding!).toString();
        res = sumTmp;
        break;
      default:
        //消費税未設定：金額がそのまま税込み金額に入る
        sumTmp = CommonPrice4FU.cnvIntPrice(sum, rounding!).toString();
        res = sumTmp;
        break;
    }

    return res;
  }
}
